import Dropdown from "./Dropdown";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import style from "../styles/menu.module.css";
// import { ChevronDown } from "lucide-react";

const MenuItems = ({ items, depthLevel }) => {
   const [dropdown, setDropdown] = useState(false);
   let ref = useRef();

   useEffect(() => {
      const handler = (event) => {
         if (dropdown && ref.current && !ref.current.contains(event.target)) {
            setDropdown(false);
         }
      };
      document.addEventListener("mousedown", handler);
      document.addEventListener("touchstart", handler);
      return () => {
         // Cleanup the event listener
         document.removeEventListener("mousedown", handler);
         document.removeEventListener("touchstart", handler);
      };
   }, [dropdown]);

   const onMouseEnter = () => {
      setDropdown(true);
   };

   const onMouseLeave = () => {
      setDropdown(false);
   };

   const toggleDropdown = () => {
      setDropdown((prev) => !prev);
   };

   const closeDropdown = () => {
      dropdown && setDropdown(false);
   };

   return (
      <li
         className="menu-items"
         ref={ref}
         onMouseEnter={onMouseEnter}
         onMouseLeave={onMouseLeave}
         onClick={closeDropdown}
      >
         {items.url && items.submenu ? (
            <>
               <button
                  type="button"
                  aria-haspopup="menu"
                  aria-expanded={dropdown ? "true" : "false"}
                  onClick={() => toggleDropdown()}
               >
                  <Link to={items.url}>
                     <div
                        style={{
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           gap: "6px",
                           textAlign: "center",
                        }}
                     >
                        {items.icon && <items.icon />}&nbsp;
                        <span
                           style={{
                              margin: 0,
                              textAlign: "center",
                              display: "inline-block",
                           }}
                        >
                           {items.title}
                        </span>
                     </div>
                  </Link>
                  {depthLevel > 0 ? (
                     <span>&raquo;</span>
                  ) : (
                     <span></span>
                     // <span ><ChevronDown/></span>
                  )}
               </button>
               <Dropdown
                  depthLevel={depthLevel}
                  submenus={items.submenu}
                  dropdown={dropdown}
               />
            </>
         ) : !items.url && items.submenu ? (
            <>
               <button
                  type="button"
                  aria-haspopup="menu"
                  aria-expanded={dropdown ? "true" : "false"}
               >
                  {items.title}
                  {depthLevel > 0 ? (
                     <span>&raquo;</span>
                  ) : (
                     <span className="arrow" />
                  )}
               </button>
               <Dropdown
                  depthLevel={depthLevel}
                  submenus={items.submenu}
                  dropdown={dropdown}
               />
            </>
         ) : (
            <Link to={items.url} title={items.title}>
               <div
                  style={{
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     gap: "6px",
                     textAlign: "center",
                  }}
               >
                  {items.icon && <items.icon />}&nbsp;
                  <span
                     style={{
                        margin: 0,
                        textAlign: "center",
                        display: "inline-block",
                     }}
                  >
                     {items.title}
                  </span>
               </div>
            </Link>
         )}
      </li>
   );
};

export default MenuItems;
